import { render, staticRenderFns } from "./ApprovalConfig.vue?vue&type=template&id=0dce4f67&scoped=true"
import script from "./ApprovalConfig.vue?vue&type=script&lang=js"
export * from "./ApprovalConfig.vue?vue&type=script&lang=js"
import style0 from "./ApprovalConfig.vue?vue&type=style&index=0&id=0dce4f67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dce4f67",
  null
  
)

export default component.exports